export const keywordModel = {
  category: 'architecture',
  subcategory: null,
  keyword: null,
}
